import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import styles from './HeroSection.module.css';
  import useCountAnimation from '../hooks/useCountAnimation';

const HeroSection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleButtonClick = useCallback(() => {
    if (user && user?.discord_user_id) { // User exists and has discord connected
      window.location.href = 'https://discord.com/channels/1283830852907827220/1283835693298090034';
    } else if (user) {
      navigate('/settings');
    } else { 
      navigate('/signup');
    }
  }, [user, navigate]);

  return (
    <div className={styles.heroContainer}>
      <div className={styles.heroContent}>
        <h1>{isMobile ? "Join Australia's Leading Sports Community" : "Join Australia's Most Advanced Sports Picks Community"}</h1>
        <p>{isMobile ? 'AI-powered insights and expert analysis for smarter betting.' : 'Harness the power of AI-driven insights, expert analysis, and proven strategies. Our members are winning bigger, smarter, and more consistently.'}</p>
        <div className={styles.statHighlights}>
          <div className={styles.stat}>
            <span className={styles.statNumber}>{useCountAnimation(400)}+</span>
            <span className={styles.statLabel}>Discord Members</span>
          </div>
          <div className={styles.stat}>
            <span className={styles.statNumber}>${useCountAnimation(1000)}+</span>
            <span className={styles.statLabel}>Monthly Profits</span>
          </div>
          <div className={styles.stat}>
            <span className={styles.statNumber}>{useCountAnimation(40)}+</span>
            <span className={styles.statLabel}>Sports Covered</span>
          </div>
        </div>  
        <button className={styles.ctaButton} onClick={handleButtonClick}>
          { user && user?.discord_user_id ? 'Go to Discord' : user ? 'Connect your Discord in Settings!' : 'Start Your Free Trial!'}
        </button>
      </div>
    </div>
  );
};

export default HeroSection;